module.exports = __webpack_public_path__ + "img/use-temp.cfc2a72e.gif";